import React, { Component } from 'react';
import EnhancedTable from '../../components/table';
import Config from '../../config';
import Moment from 'react-moment';
import DownloadButton from '../../components/download_button';
import { getCompanyNames } from '../../helpers';

// table.tsx's default export is withRouter(...)-wrapped; withRouter's TS
// overload narrows the wrapped props regardless of the underlying
// component's own typing, hiding the `config` surface. table.tsx's export is
// already widened to React.ComponentType<any> for this reason, so this cast
// is now redundant but harmless; left as-is to keep this change scoped to
// the .js-extension import sweep.
const TypedEnhancedTable = EnhancedTable as React.ComponentType<any>;

interface AttachmentsProps {
    setTitle?: (title: string) => void;
}

class Attachments extends Component<AttachmentsProps> {
    state = {};

    componentDidMount() {
        if(this.props.setTitle) {
            this.props.setTitle('Attachments');
        }
    }

    convertSize(bytes: number | null){
        if (bytes === null) {
            return null;
        }
         if (bytes / (1024 * 1024) > 1) {
            return (bytes / (1024 * 1024)).toFixed(2) + " MB";
         } else if (bytes / 1024 > 1) {
             return (bytes / 1024).toFixed(2) + " KB";
         }
         return bytes + " B";
    }
    render(){
        var config = {
            url: Config.api + "/odata/Company/Attachments",
            columns: [
              { id: "Id", hidden: true},
              { id: 'CreateDate', type:'date', filterable: true, sortable: true, label: 'Date', template: (value: string) => (<Moment format='MM/DD/YYYY hh:mm A'>{value}</Moment>), width: '11em' },
              { id: 'CompanyName', filterable: true, label: 'Sender', width: '12em', getOptions: getCompanyNames },
              { id: 'PartnerCompanyName', filterable: true, label: 'Receiver', width: '12em', getOptions: getCompanyNames },
              { id: 'Description', filterable: true, label: 'Description', allowStringOperators: true },
              { id: 'Type', filterable: true, label: 'Type', width: '8em' },
              { id: 'Size', sortable: true, label: 'Size', numeric: true, width: '5em', template: (value: number | null) => this.convertSize(value) },
              { id: 'BlobPath', width: '10em', template: (value: string) => {return (<DownloadButton size='small' variant='outlined' href={value}>Download</DownloadButton>);}}
          ],
          order: 'desc',
          orderBy: 'Id',
          keyField: 'Id',
          pageSize: 20,
          pageSizes: [10, 20, 50, 100],
          filterInUrl: true,
          title: 'Attachments',
          filter: {logic: "and", filters: [{field: "Duplicate", operator: 'eq', value: false}]}
      };
        return <TypedEnhancedTable config={config}/>;
    }
}

export default Attachments;
